// Ant Design
import { Layout } from 'antd';
import { useSelector } from 'react-redux';

// project import
import { drawerWidth } from '@/config';
import { getSidebarColor } from '@/themes/antd-theme';
import { useTheme } from '@/App';

const { Sider } = Layout;

// Collapsed width constant
export const collapsedWidth = 80;

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = ({ open, children, ...other }) => {
  const { theme_color } = useSelector((state) => state.company_profile);
  const { isDark } = useTheme();

  // Get sidebar color based on dark/light mode
  const bgColor = getSidebarColor(theme_color, isDark);
  const width = open ? drawerWidth : collapsedWidth;

  return (
    <Sider
      {...other}
      width={width}
      collapsed={!open}
      collapsedWidth={collapsedWidth}
      trigger={null}
      className="overflow-visible"
      style={{
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        // Kept present in both states (never toggled to the literal 'none') —
        // box-shadow/border can't smoothly interpolate to/from 'none', so
        // switching them on/off snapped in abruptly right as the width
        // transition finished, looking like a sudden flash.
        borderRight: '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        overflow: 'visible',
        position: 'fixed',
        left: 0,
        top: 0,
        // Above the header (z-[1200]) so the sidebar overlays it, rather than
        // pushing/resizing it, while expanded.
        zIndex: 1300,
        height: '100vh',
        minHeight: '100vh',
        backgroundColor: bgColor,
        // Set directly on the style attribute (not a class) so it always wins
        // over AntD's own injected width-transition rule for .ant-layout-sider —
        // the two competing declarations were racing each other and made the
        // open/close animation look like it froze partway through.
        transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s ease, border-right 0.4s ease',
      }}
    >
      {children}
    </Sider>
  );
};

export default MiniDrawerStyled;
